import * as BABYLON from "babylonjs";
import * as _ from "lodash";
import { CoordUtils } from "../core/coordUtils";
import { GeoBoundingBox } from "../core/geoBoundingBox";
import { GeoPoint } from "../core/geoPoint";

export enum LandLevel {
    Continent,
    SubContinent,
    Country
}

export abstract class Land {
    isoCode: string;
    focusPosition: GeoPoint;
    cameraAltitude: number;
    defaultAltitude: number = 0.5;

    abstract parent: Land | null;
    abstract children: Land[];

    getLeafChildren(): Land[] {
        if (this.children.length == 0) {
            return [this];
        } else {
            return _.flatMap(this.children, it => it.getLeafChildren());
        }
    }

    isVisibleByCamera(camera: BABYLON.Camera, horizontalMargin: number, depthMargin: number): boolean {
        let minXY = -1 + horizontalMargin;
        let maxXY = 1 - horizontalMargin;
        let maxZ = 1 - depthMargin;
        let transform = camera.getTranformationMatrix();
        let position = CoordUtils.geoToBabylon(this.focusPosition);
        let projected = BABYLON.Vector3.TransformCoordinates(position, transform);
        return projected.x > minXY && projected.x < maxXY && projected.y > minXY && projected.y < maxXY && projected.z < maxZ;
    }

    computeFocusPositionAndCameraAltitudeFromChildren() {
        let focusPoints = this.getLeafChildren().map(it => it.focusPosition);
        let boundingBox = GeoBoundingBox.fromPoints(focusPoints);
        this.focusPosition = boundingBox.center;
        this.cameraAltitude = this.defaultAltitude;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/model/land.ts